const types = {
  GET_PRODUCT_START: 'GET_PRODUCT_START',
  GET_PRODUCTS_SUCCESS: 'GET_PRODUCTS_SUCCESS',
  GET_PRODUCTS_FAILURE: 'GET_PRODUCTS_FAILURE',
  UPDATE_PRODUCT_FAILURE: 'UPDATE_PRODUCT_FAILURE',
  GET_PRODUCT_COLLECTIONS_START: 'GET_PRODUCT_COLLECTIONS_START',
  GET_PRODUCT_COLLECTIONS_SUCCESS: 'GET_PRODUCT_COLLECTIONS_SUCCESS',
  GET_PRODUCT_COLLECTIONS_FAIL: 'GET_PRODUCT_COLLECTIONS_FAIL',
  GET_ONE_PRODUCT_COLLECTIONS_START: 'GET_ONE_PRODUCT_COLLECTIONS_START',
  GET_ONE_PRODUCT_COLLECTIONS_SUCCESS: 'GET_ONE_PRODUCT_COLLECTIONS_SUCCESS',
  GET_ONE_PRODUCT_COLLECTIONS_FAIL: 'GET_ONE_PRODUCT_COLLECTIONS_FAIL',
  CLEAR_CURRENT_PRODUCT_COLLECTIONS: 'CLEAR_CURRENT_PRODUCT_COLLECTIONS',
  GET_ALL_PRODUCT_COLLECTIONS_START: 'GET_ALL_PRODUCT_COLLECTIONS_START',
  GET_ALL_PRODUCT_COLLECTIONS_SUCCESS: 'GET_ALL_PRODUCT_COLLECTIONS_SUCCESS',
  GET_ALL_PRODUCT_COLLECTIONS_FAIL: 'GET_ALL_PRODUCT_COLLECTIONS_FAIL',
  GET_ALL_PRODUCTS_START: 'GET_ALL_PRODUCTS_START',
  GET_ALL_PRODUCTS_SUCCESS: 'GET_ALL_PRODUCTS_SUCCESS',
  GET_ALL_PRODUCTS_FAILURE: 'GET_ALL_PRODUCTS_FAILURE',
};
export default types;
